import React, { useRef,useMemo } from "react";
import { Button } from "primereact/button";
import "./DeleteUser.css";
import { useMutation } from 'react-query';
import { Toast } from 'primereact/toast';
import { useUser } from "../../../../../Context/UserContext";
import { useClient } from "../../../../../Context/ClientContext";
import { instance } from "../../../../../api";
export default function DeleteUser({
  setDialogDelete, refetch
}) {

  const toast = useRef(null);
  const {selectedUser , setUsers, setUserList,users}=useUser()
  const{selectedClient,client }=useClient()
  const targetUser = useMemo(() => {
    const list = users ? Object.values(users) : [];
    return list.find(
      (u) => u?.id_utilisateur_gexonline === selectedUser
    ) || null;
  }, [users, selectedUser]);
  const targetClient = useMemo(() => {
    const list = client ? Object.values(client) : [];
    return list.find(
      (c) => c?.id_client_gexpertise === selectedClient
    ) || null;
  }, [client, selectedClient]);

  // Nom à afficher pour le client (entreprise / particulier) avec fallbacks
  const clientDisplayName =
    targetClient?.nom_entreprise ||
    targetClient?.raison_sociale ||
    targetClient?.nom_particulier ||
    targetClient?.nom ||
    targetClient?.libelle ||
    "ce client";

  const Supprimer = useMutation (
    () => {
      return instance.delete(`/api/utilisateurs/clients/${selectedClient}/utilisateur/${selectedUser}`)
    },
    {
      onSuccess: () => {
        toast.current.show({
          severity: 'success',
          summary: 'Succès ',
          detail: 'Utilisateur supprimé  ',
          life: 2000,
        });
        setTimeout(() => {
          setDialogDelete(false);
        }, 1300);
        refetch()
      }, 
      
    }
  );
   



  return (
  <div>
    <Toast ref={toast} />

    {Supprimer.isLoading ? (
      <div className="flex flex-col items-center justify-center py-6">
        {/* Either icon spinner... */}
        <i className="pi pi-spin pi-spinner" style={{ fontSize: "2rem", color: "#b71c1c" }} />
        {/* ...or ProgressSpinner if you imported it: <ProgressSpinner /> */}
        <p className="mt-3">Suppression en cours...</p>
      </div>
    ) : (
      <>
        <p style={{ lineHeight: 1.5 }}>
          Voulez-vous supprimer l’accès de{" "}
          <strong>
            {targetUser
              ? `${targetUser.prenom || ""} ${targetUser.nom || ""}`.trim()
              : "cet utilisateur"}{" "}
            {targetUser?.email ? `[${targetUser.email}]` : ""}
          </strong>{" "}
          au compte GexOnline de <strong>{clientDisplayName}</strong> ?
        </p>

        <Button
          type="button"
          label="Annuler"
          icon="pi pi-times"
          className="p-button-text"
          onClick={() => setDialogDelete(false)}
          disabled={Supprimer.isLoading}
        />
        <Button
          type="button"
          label={Supprimer.isLoading ? "Suppression..." : "CONFIRMER"}
          icon={Supprimer.isLoading ? "pi pi-spin pi-spinner" : "pi pi-check"}
          className="p-button-text p-button-danger"
          onClick={() => Supprimer.mutate()}
          disabled={Supprimer.isLoading}
        />
      </>
    )}
  </div>
);
}